var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-project-block container my-3" }, [
    _c("h6", { staticClass: "create-project-header" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["myProject.Project.ShareProject.Title"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.hideModal("share-project")
          }
        }
      },
      [
        _c("span", {
          staticClass: "png-icon png-icon-icons-glyph--k-close",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "my-3" },
      [
        _c(
          "label",
          {
            ref: "shareProject",
            staticClass: "label-before-switch label-size-12 text-uppercase"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["common.Sharetray.Label.Link"]) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2 d-flex" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.projectUrl,
                expression: "projectUrl"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "sharable_link",
              "aria-describedby": "basic-addon3",
              disabled: ""
            },
            domProps: { value: _vm.projectUrl },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.projectUrl = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "copy-link-btn btn btn-primary py-0",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleCopyUrl($event)
                }
              }
            },
            [_vm._v("Copy")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "font-16 pb-3", staticStyle: { color: "gray" } },
          [
            _c("span", { staticClass: "font-16" }, [
              _vm._v(
                _vm._s(
                  _vm.$resourceString[
                    "myProject.Project.ShareProject.SharableLinkDescription"
                  ]
                )
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "label-size-12 text-uppercase",
            attrs: { for: "invite_people-shareProject" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["account.ShareTray.Label.InvitePeople"]
                ) +
                "*\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mb-2 d-flex justify-content-between align-items-center form-group-shareproject position-relative mb-2"
          },
          [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newEmail,
                    expression: "newEmail"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: "invite_people-shareProject",
                  placeholder:
                    _vm.$resourceString[
                      "account.MyProject.EmailField.Placeholder"
                    ]
                },
                domProps: { value: _vm.newEmail },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addEmail($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-group-append input-container-shareProject"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: " btn-primary small-button-shareProject ",
                      class:
                        _vm.newEmail.length <= 0 ? "disabled-shareProject" : "",
                      attrs: { disabled: _vm.newEmail.length == 0 },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addEmail($event)
                        }
                      }
                    },
                    [_vm._v("\n            +\n          ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "input-group-append roles-dropdown-createProject"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "border-0 btn btn-primary bg-white text-accent-black",
                      attrs: {
                        "aria-haspopup": "true",
                        "aria-expanded": "true",
                        id: "board-roles-dropdown-toggle",
                        type: "button",
                        "data-toggle": "dropdown"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.selectedRole.label) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "rounded dropdown-menu dropdown-menu-right bg-white label-size-12"
                    },
                    _vm._l(_vm.roles, function(role, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "dropdown-item",
                          attrs: { href: "", role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.selectRole(role)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "item-texts d-flex justify-content-center",
                              staticStyle: { "flex-direction": "column" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "role-label role-label-font-wt text-uppercase"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(role.label) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "role-description" }, [
                                _vm._v(_vm._s(role.description))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          role === _vm.selectedRole
                            ? _c("div", { staticClass: "icon-holder" }, [
                                _c("i", {
                                  staticClass: "fal fa-check",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.emails, function(email, index) {
          return _c(
            "div",
            { key: index, staticClass: "wf-current-refinements-group" },
            [
              _c(
                "a",
                {
                  staticClass:
                    "btn btn-white shadow-sm mx-1 my-1 bg-dark text-light text-transform-none"
                },
                [
                  _vm._v("\n        " + _vm._s(email) + "\n\n        "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "png-icon png-icon-icons-glyph--k-close email-remove-icon",
                      on: {
                        click: function($event) {
                          return _vm.removeEmail(index)
                        }
                      }
                    },
                    [_vm._v("×")]
                  )
                ]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("p", { staticClass: "text-danger font-16" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.validationError.registeredEmail
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.Role.Error"
                    ]
                  : _vm.validationError.invitePeople
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.Required.Error"
                    ]
                  : _vm.validationError.validEmail
                  ? _vm.$resourceString[
                      "virtualtray.Sharetray.Email.ValidEmail.Error"
                    ]
                  : ""
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "label-size-12 text-uppercase",
            attrs: { for: "email_subject" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["account.ShareTray.Label.EmailSubject"]
                ) +
                "*\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: " mb-3" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailSubject,
                expression: "emailSubject"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "email_subject",
              placeholder:
                _vm.$resourceString[
                  "account.MyProject.EmailFieldSubject.Placeholder"
                ]
            },
            domProps: { value: _vm.emailSubject },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.emailSubject = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.validationError.emailSubject
            ? _c("p", { staticClass: "text-danger font-16" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$resourceString["virtualtray.Sharetray.Subject.Error"]
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "label-size-12 text-uppercase",
            attrs: { for: "tray-description" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["common.Sharetray.EmailNote.Label"]
                ) +
                "\n      "
            ),
            _c("span", { staticClass: "optional-field ml-3" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$resourceString["contentWizard.Label.Field.Optional"]
                  ) +
                  " "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-group mb-4" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.emailNote,
                expression: "emailNote"
              }
            ],
            staticClass: "form-control",
            attrs: {
              id: "tray-description",
              "aria-label": "With textarea",
              placeholder:
                _vm.$resourceString[
                  "account.MyProject.EmailFieldNote.Placeholder"
                ]
            },
            domProps: { value: _vm.emailNote },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.emailNote = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "send-btn-row row" }, [
          _c("div", { staticClass: "send-btn-col col" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-primary",
                on: { click: _vm.shareTrayItem }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.ShareProject.SendInvite.Title"
                      ]
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "accordion",
            attrs: { id: "who-has-access-to-project" }
          },
          [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "who-has-access-hover label-size-12 text-uppercase",
                    attrs: {
                      id: "user-with-access-dropdown-toggle",
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#who-has-access",
                      "aria-expanded": "false",
                      "aria-controls": "who-has-access"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleWHA($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$resourceString[
                            "myProject.Project.ShareProject.WhoHasAcess.label"
                          ]
                        ) +
                        "\n            " +
                        _vm._s("(" + _vm.getprojectUsers.length + ")") +
                        "\n            "
                    ),
                    _c("span", {
                      staticClass:
                        "png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0",
                      style: _vm.transform ? "transform: rotate(180deg)" : ""
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "collapse", attrs: { id: "who-has-access" } },
                [
                  _c("div", { staticClass: "false card-body" }, [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "users-with-access-list label-size-12 text-uppercase"
                      },
                      _vm._l(_vm.getprojectUsers, function(user) {
                        return _c(
                          "li",
                          {
                            staticClass:
                              "users-with-access-list__item label-size-12"
                          },
                          [
                            _c("span", { staticClass: "name-email" }, [
                              _c("span", [_vm._v(_vm._s(user.userName))]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "color-secondary text-lowercase"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(user.email) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            user.role === _vm.BoardRoles.owner
                              ? _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "myProject.shareTray.Title.Dropdown.Owner"
                                        ]
                                      ) +
                                      "\n                "
                                  )
                                ])
                              : _c("div", { staticClass: "dropdown" }, [
                                  user.role === _vm.BoardRoles.collaborator &&
                                  _vm.projectDetails.role !=
                                    _vm.BoardRoles.owner
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "myProject.Project.ShareProject.Collaborator.Label"
                                              ]
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : user.role === _vm.BoardRoles.viewer &&
                                      _vm.projectDetails.role !=
                                        _vm.BoardRoles.owner
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "myProject.Project.ShareProject.Viewer.Label"
                                              ]
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                            _vm._v(" "),
                            _vm.projectDetails.role == _vm.BoardRoles.owner &&
                            _vm.checkRole(user.role) !== _vm.ownerResourceString
                              ? _c(
                                  "div",
                                  { staticClass: "dropdown" },
                                  [
                                    _c("my-project-roles-dropdown", {
                                      attrs: {
                                        checkRole: _vm.checkRole,
                                        isRemoveAccess: _vm.isAdmin
                                          ? true
                                          : user.role == _vm.BoardRoles.owner
                                          ? true
                                          : user.email != _vm.userEmail,
                                        user: user,
                                        roles: _vm.roles
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-primary mt-2",
              on: { click: _vm.handleModalClose }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$resourceString["virtualtray.Savetray.Cancel.Button"]
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2 float-right pb-4" }, [
            _vm.projectDetails.role == _vm.BoardRoles.owner || _vm.isAdmin
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary",
                    on: { click: _vm.handleStopSharing }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$resourceString[
                            "myProject.Project.ShareProject.StopSharing.label"
                          ]
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: _vm.isDisabled },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleSave($event)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.ShareProject.Save.label"
                      ]
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }